import { connect } from 'react-redux'
import DeadMansHandleContent from './DeadMansHandleContent'
import { extendGigTermination } from '../../dataStore/actions/gig/gigActions'
import { State } from '../../dataStore/reducers/reducerType'
import { DeadMansHandleContentProps} from './types'

type Dispatch = 'onConfirm'

const mapStateToProps = (state: State): Omit<DeadMansHandleContentProps, 'history' | 'match' | Dispatch> => ({
  datetime: state.ui.liveDateTime ? state.ui.liveDateTime : '',
  gigTerminationTime: state.room.gigTerminationTime ? state.room.gigTerminationTime : '',
  isDeadMansHandleOpen: state.ui.isDeadMansHandleOpen
})
const mapDispatchToProps = (dispatch): Pick<DeadMansHandleContentProps, Dispatch> => ({
  onConfirm: () => dispatch(extendGigTermination())
})

export default connect(mapStateToProps, mapDispatchToProps)(DeadMansHandleContent)
